<script setup lang="ts">
import { EventFlag, MotionItemType } from '@/api/models/definitions'

import MotionListRowItemFlag from '@/modules/motion/components/list/MotionListRowItemFlag.vue'
import MotionListRowItemType from '@/modules/motion/components/list/MotionListRowItemType.vue'

interface Props {
  primary?: string
  secondary?: string
}

defineProps<Props>()
</script>

<template>
  <div class="flex items-center justify-center p-3 bg-gray-100">
    <div class="basis-1/3 rounded-tl-lg">
      <div class="flex rounded-br-lg bg-white">
        <div class="bg-gray-500 rounded-tl-md w-2"></div>
        <div class="flex-1 text-xs rounded-br-lg p-1 min-w-0 relative border border-gray-500">
          <div class="space-y-1">
            <div class="relative flex gap-1 border border-dashed border-brand p-0.5">
              <MotionListRowItemType :type="MotionItemType.Shipment" />
              <div class="font-bold truncate">&lt;{{ primary }}&gt;</div>
            </div>
            <div class="relative flex border border-dashed border-brand p-0.5">
              <div class="truncate">&lt;{{ secondary }}&gt;</div>
              <MotionListRowItemFlag :status="EventFlag.Normal" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
